module.exports = __webpack_public_path__ + "img/alarm_icon.750e0a3d.png";